import { deleteRequest, postRequest } from 'helpers/axios';

const BASE_URL = '';

const register = (body) => {
  return postRequest(BASE_URL + 'signup', body).then((response) => {
    if (response?.data) {
      const payload = {
        ...response.data.user,
        token:
          response.headers?.authorization || response.headers?.Authorization,
      };
      if (!!payload.confirmed_at) {
        localStorage.setItem('user', JSON.stringify(payload));
      }
      return payload;
    }
  });
};

const login = (body) => {
  return postRequest(BASE_URL + 'login', body).then((response) => {
    if (response?.data) {
      const payload = {
        ...response.data.user,
        token:
          response.headers?.authorization || response.headers?.Authorization,
      };
      localStorage.setItem('user', JSON.stringify(payload));
      return payload;
    }
  });
};

const sumoLogin = (body, code) => {
  let url = `${BASE_URL}login`;
  if (code) {
    url += `?code=${encodeURIComponent(code)}`;
  }

  return postRequest(url, body).then((response) => {
    if (response?.data.user) {
      const payload = {
        ...response.data.user,
        token:
          response.headers?.authorization || response.headers?.Authorization,
      };
      localStorage.setItem('user', JSON.stringify(payload));
    }
    if (response?.data) {
      return response.data;
    }
  });
};

const socialLogin = (body) => {
  const { googleAccessToken } = body || {};
  return postRequest(BASE_URL + 'auth/request', body, {
    Token: googleAccessToken,
  }).then((response) => {
    if (response?.data) {
      const payload = {
        ...response.data.user,
        token:
          response.headers?.authorization || response.headers?.Authorization,
      };
      localStorage.setItem('user', JSON.stringify(payload));

      return payload;
    }
  });
};

const logout = () => {
  return deleteRequest(BASE_URL + 'logout').then((response) => {
    if (response?.status === 200) {
      localStorage.removeItem('user');
    }
  });
};

const authService = {
  register,
  login,
  logout,
  socialLogin,
  sumoLogin,
};

export default authService;
